import { useMemo, useState } from 'react'
import { filterTasks, tsToDate, dueMeta, chipStyle } from '../lib/format.js'
import { Calendar } from '../ds/index.js'

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

export default function CalendarView({
  tasks,
  labelFilter,
  assigneeFilter,
  phaseFilter,
  incompleteOnly,
  dueSoonOnly,
  search,
  statusesById,
  onOpenTask,
  month,
}) {
  const [displayed, setDisplayed] = useState(() => month || new Date())

  const year = displayed.getFullYear()
  const monthIndex = displayed.getMonth()

  const { leadingBlanks, dayCount } = useMemo(() => {
    const firstOfMonth = new Date(year, monthIndex, 1)
    const lastOfMonth = new Date(year, monthIndex + 1, 0)
    return { leadingBlanks: firstOfMonth.getDay(), dayCount: lastOfMonth.getDate() }
  }, [year, monthIndex])

  const filtered = useMemo(
    () => filterTasks(tasks, { labelFilter, assigneeFilter, phaseFilter, incompleteOnly, dueSoonOnly, search, statusesById }),
    [tasks, labelFilter, assigneeFilter, phaseFilter, incompleteOnly, dueSoonOnly, search, statusesById],
  )

  const tasksByDay = useMemo(() => {
    const map = {}
    for (const t of filtered) {
      const d = tsToDate(t.dueDate)
      if (!d) continue
      if (d.getFullYear() !== year || d.getMonth() !== monthIndex) continue
      const day = d.getDate()
      if (!map[day]) map[day] = []
      map[day].push(t)
    }
    return map
  }, [filtered, year, monthIndex])

  const goPrev = () => setDisplayed((d) => new Date(d.getFullYear(), d.getMonth() - 1, 1))
  const goNext = () => setDisplayed((d) => new Date(d.getFullYear(), d.getMonth() + 1, 1))

  const days = Array.from({ length: dayCount }, (_, i) => {
    const dayNum = i + 1
    const dayTasks = tasksByDay[dayNum] || []
    return {
      key: dayNum,
      label: dayNum,
      empty: dayTasks.length === 0,
      events: dayTasks.map((t) => {
        const done = !!statusesById?.[t.status]?.done
        const meta = dueMeta(tsToDate(t.dueDate), done)
        return (
          <button
            key={t.id}
            onClick={() => onOpenTask(t.id)}
            title={t.title}
            style={{
              ...chipStyle(meta.overdue ? 'var(--color-danger)' : 'var(--color-gold)'),
              cursor: 'pointer',
              width: '100%',
              boxSizing: 'border-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textTransform: 'none',
              letterSpacing: 0,
              textAlign: 'left',
            }}
          >
            {t.title}
          </button>
        )
      }),
    }
  })

  return (
    <div>
      <Calendar
        title={`${MONTH_NAMES[monthIndex]} ${year}`}
        onPrev={goPrev}
        onNext={goNext}
        leadingBlanks={leadingBlanks}
        days={days}
      />
    </div>
  )
}
